import type { AssignedUser, CreateTaskPayload, MondayBoardTarget } from "./types";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "";

export interface CreateTaskResponse {
  success: boolean;
  itemId?: string;
  message: string;
  errors?: string[];
}

export interface MondayTargetsResponse {
  success: boolean;
  boards: MondayBoardTarget[];
  assignedUsers?: AssignedUser[];
  message?: string;
}

export interface MondayTargets {
  boards: MondayBoardTarget[];
  assignedUsers: AssignedUser[];
}

export async function fetchMondayTargets(): Promise<MondayTargets> {
  const response = await fetch(`${API_BASE_URL}/api/monday-targets`);
  const data = (await response.json().catch(() => null)) as MondayTargetsResponse | null;

  if (!response.ok || !data?.success) {
    const status = response.status;
    const message = data?.message || "Unable to load monday.com board options.";
    throw new Error(`${message} (Status: ${status})`);
  }

  return {
    boards: data.boards,
    assignedUsers: data.assignedUsers || []
  };
}

export async function createMondayTask(payload: CreateTaskPayload): Promise<CreateTaskResponse> {
  const response = await fetch(`${API_BASE_URL}/api/create-monday-task`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  let data: CreateTaskResponse;

  try {
    data = await response.json();
  } catch {
    throw new Error("Backend returned an invalid response.");
  }

  if (!response.ok || !data.success) {
    const details = data.errors?.length ? ` ${data.errors.join(" ")}` : "";
    throw new Error(`${data.message || "Unable to create task."}${details}`);
  }

  return data;
}
